module.exports = __webpack_public_path__ + "static/media/ZylaandKaiBookCover.858c25b4.jpg";